// Сворачиваемая панель PrimeVue переключается только кнопкой-шевроном. Делаем
// кликабельным весь заголовок: щелчок по нему передаём шеврону этой панели.
// Один делегированный обработчик на документ - без правок в каждой панели.

// Внутри заголовка бывают свои кнопки и поля (например, «Добавить») - их щелчок
// панель не трогает. Сам шеврон тоже пропускаем: он переключит панель сам.
const INTERACTIVE = "button, a, input, select, textarea, label, [role='button'], .multiselect";

const onClick = (event) => {
  const header = event.target.closest?.(".p-panel.p-panel-toggleable > .p-panel-header");
  if (!header) return;
  if (event.target.closest(INTERACTIVE)) return;
  //выделяли текст заголовка - это не щелчок
  if (window.getSelection()?.toString()) return;

  header.querySelector(":scope > .p-panel-icons > .p-panel-toggler")?.click();
};

export function InitPanelHeaderToggle() {
  document.addEventListener("click", onClick);
}
